import LinearProgress from '@mui/material/LinearProgress'

import LoaderWrapper from './LoaderWrapper'

const Loader: React.FC = () => (
  <LoaderWrapper>
    <LinearProgress />
  </LoaderWrapper>
)

export default Loader
